import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./plugins/element.js";
import { createProvider } from "./vue-apollo";
import "./vendor";
import "./global";
import VueAnalytics from "vue-analytics";

Vue.config.productionTip = false;

const isProd = process.env.NODE_ENV == "production";

Vue.use(VueAnalytics, {
	id: "UA-70028943-4",
	router,
	autoTracking: {
		exception: true
	},
	debug: {
		enabled: !isProd,
		sendHitTask: isProd
	}
});

window.vue = new Vue({
	router,
	apolloProvider: createProvider(),
	render: h => h(App)
}).$mount("#app");
